import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';
import '../Edit/style.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { withStyles } from '@mui/styles';
import { compose } from 'recompose';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import GridLayout from "react-grid-layout";
import _ from "lodash";

import AddColFields, { addColInitial } from './AddCol';
import { Modal } from '../../_Components';
import { Options } from '../../_utils/_constants';

const typeName = (id) => {
    const item = Options.FieldsTypesOptions.find((option) => option.id === id);
    return item ? item.name : (id || '');
};


const styles = {
    row: {
        display: 'flex',
        paddingBottom: '1em'
    },
    settings: {
        display: 'inline-flex',
        marginRight: '2em'
    },
    radio: {
        paddingRight: 30
    },
    button: {
        // float: 'right',
        marginBottom: 10,
    },
    selectedCol: {
        background: '#0b2b61',
        '& .textOfElement': {
            color: '#fff'
        }
    },
    icon: {
        cursor: 'pointer', 
        width: '0.75em', 
        marginTop: 6
    },
    ul: {
        padding: 0
    },
    li: {
        border: '1px solid',
        listStyle: 'none',
        background: 'white',
        marginBottom: 1,
        cursor: 'pointer'
    },
    liActive: {
        backgroundColor: '#0a2b61',
        color: '#ffff',
        border: '1px solid',
        listStyle: 'none',
        background: 'white',
        marginBottom: 1,
        cursor: 'pointer'
    },
    handleIcon: {
        verticalAlign: 'middle',
        paddingLeft: 10,
    },
    deleteIcon: {
        verticalAlign: 'middle',
        color: 'red',
        paddingRight: 8,
        float: 'right',
        fontSize: '1.25rem !important'
    },
    editIcon: {
        verticalAlign: 'middle',
        color: '#0a2b61',
        paddingRight: 8,
        float: 'right',
        fontSize: '1.25rem !important'
    },
    addIcon: {
        verticalAlign: 'middle',
        color: '#009688',
        paddingRight: 8,
        float: 'right',
        fontSize: '1.25rem !important'
    },
    label: {
        verticalAlign: 'middle',
        paddingLeft: 10,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '85%',
        display:' block',
        fontSize: '0.875rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: '1.43',
        letterSpacing: '0.01071em'
    },
    script: {
        display: 'flex',
    },
    list: {
        flex: 'auto',
        height: 'calc(100vh - 240px)',
        width: '56.5%'
    },
    edit: {
        flex: 'auto',
        marginLeft: '1em',
        height: 'calc(100vh - 240px)',
        width: '44%'
    },
    editor: {
        '& .rdw-editor-main' : {
            height: '70%',
            borderRadius: '2px',
            border: '1px solid #F1F1F1'
        }
    },
    cardHeader: {
        padding:' 8px 16px 0px 0px'
    },
    cardContent: {
        height: 'calc(100vh - 320px)',
        overflow: 'auto',
        position: 'relative',
        padding: '0px 8px 0px 8px'
    },
    cardHeaderTitile: {
        width: 'fit-content'
    },
    cardHeaderAction: {
        flex: 'auto',
        width: '-webkit-fill-available'
    },
    actionButtons: {
        display: 'flex',
    },
    panelRoot: {
        padding: '0 8px 0 0',
        maxHeight: 24,
        minHeight: 'unset',
        '&.Mui-expanded': {
            minHeight: 'unset',
        }
    },
    panelContent: {
        display: 'block'
    },
    required: {
        ckolor: 'red'
    }

}

class CardComponent extends React.PureComponent {
    static defaultProps = {
        className: "layout",
        width: 700,
        cols: 12,
        autoSize: false,
        rowHeight: 48,
        maxRows: 4,
        margin: [8, 8],
        marginTop: 0
    };

    constructor(props) {
        super(props);
        this.state = {
            oldlayout: null,
            openNew: false,
            items: props.elements.map((el, index) => {
                return{
                    i: el.field,
                    x: el.col,
                    y: el.row,
                    w: el.sizeX,
                    h: el.sizeY,
                    maxH: 1,
                }
            })
        };

        this.onAddItem = this.onAddItem.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.addCol = this.addCol.bind(this);
        this.closeAddColl = this.closeAddColl.bind(this);
        this.updateItems = this.updateItems.bind(this);
        if (props.registerAdd) {
            props.registerAdd(this.addCol);
        }


    }

    createElement(el, index, fields) {
        const { selectedIndex, selectCol, elements } = this.props;
        const i = el.i;
        const meta = (fields || []).find((entry) => entry.id === i);
        const col = (elements || []).find((entry) => entry.field === i);
        const name = meta ? meta.name : 'Новый элемент';
        const type = meta ? typeName(meta.type) : '';
        const required = col ? !!col.required : false;
        return (
            <div
                key={i}
                data-grid={el}
                className={selectedIndex === index ? 'is-cur' : ''}
                onClick={() => selectCol && selectCol(i)}
            >
                <span className="pc-fbox__fn">
                    {name}
                    {required ? <i>*</i> : null}
                </span>
                <span className="pc-fbox__fk">{i}{type ? ` · ${type}` : ''}</span>
                <button
                    type="button"
                    className="pc-fbox__rm"
                    title="Убрать из формы"
                    onClick={(event) => {
                        event.stopPropagation();
                        this.onRemoveItem(i);
                    }}
                >
                    <CloseIcon sx={{ fontSize: 12 }} />
                </button>
            </div>
        );
    }

    componentDidUpdate() {
        const { items } = this.state;
        const { formValues, actions, activeNodekey, selectedIndex } = this.props;
        const el = items[selectedIndex];
        if(el && formValues){
            if(actions){
                const col = formValues.actions && formValues.actions[activeNodekey] && formValues.actions[activeNodekey].cols && formValues.actions[activeNodekey].cols[selectedIndex];
                if(col && el.i!==col.field){
                    items[selectedIndex].i = col.field;
                    this.updateItems(items)
                }
            }else{
                const col = formValues.cols && formValues.cols[selectedIndex];
                if(col && el.i!==col.field){
                    items[selectedIndex].i = col.field;
                    this.updateItems(items)
                }
            }
        }
    }

    updateItems(items){
        this.setState({ items })
    }

    onLayoutChange(layout){
        const { formValues, change, activeNodekey, actions } = this.props;
        const { items } = this.state;
        if (!formValues || !change) return;
        const prevCols = actions
            ? ((formValues.actions[activeNodekey] && formValues.actions[activeNodekey].cols) || [])
            : (formValues.cols || []);
        const newItems =  items.map( (el,i) => {
            const item = layout[`${i}`] || el;
            return {
                ...el,
                x: item.x,
                y: item.y,
                w: item.w,
                h: item.h,
            }
        });
        const newCols = newItems.map( (item) => {
            const el = prevCols.find( col => col.field=== item.i);
            return {
                ...el,
                col : item.x,
                row : item.y,
                sizeX : item.w,
                sizeY: item.h,
            };
        });
        const unchanged = newCols.length === prevCols.length && newCols.every((col) => {
            const prev = prevCols.find((entry) => entry.field === col.field);
            return prev && prev.col === col.col && prev.row === col.row && prev.sizeX === col.sizeX && prev.sizeY === col.sizeY;
        });
        if (unchanged) {
            this.setState({ items: newItems });
            return;
        }
        if(actions){
            change(`actions[${activeNodekey}].cols`, newCols);
        }else{
            change('cols', newCols);
        }
        this.setState({
            items: newItems
        });
    };

    addCol() {
        this.setState({openNew: true});
    }

    closeAddColl() {
        this.setState({openNew: false});
    }

    onAddItem(newElement) {
        const { addItem } = this.props
        if(this.state.oldlayout) for (const oldlayoutElement of this.state.oldlayout) { //ограничение добавления элементов больше чем количество рядов
            if(oldlayoutElement.y === this.props.maxRows - 1 && oldlayoutElement.x + oldlayoutElement.w > this.props.cols - 5) return;
        }
        const { items } = this.state;
        const newItem = {
                i: newElement.field,
                x: (items.length * 3) % 12,
                y: Infinity, // puts it at the bottom
                w: 3,
                h: 1,
                maxH: 1,
        }
        // newElement.x = (items.length * 2) % 12;
        // newElement.y = Infinity;
        // newElement.w = 2;
        // newElement.h = 1;
        this.setState({
            // Add a new item. It must have a unique key!
            items: this.state.items.concat(newItem),
            openNew: false
        }, addItem(newElement));
    }

    onRemoveItem(index) {
        const { formValues, actions, activeNodekey, change, selectCol, selectedIndex } = this.props;
        const { items } = this.state;
        const i = _.findIndex(items, {i: index});
        const { cols } = actions ? formValues.actions[activeNodekey] : formValues;
        const k = _.findIndex(cols, {field: index});
        items.splice(i,1);
        cols.splice(k,1)
        this.setState({items}, () =>  {
            if(actions){
                change(`actions[${activeNodekey}].cols`, cols);
            }else{
                change('cols', cols);
            }
            if(selectedIndex===i){
                selectCol(0);
            }
            return
        });
    }

    render() {
        const styleGrid ={
            width: this.props.width + 'px',
            height: (this.props.rowHeight + 10) * this.props.maxRows + 10 + 'px',
            marginTop: this.props.marginTop
        };
        const { fields, hideAdd, className, cols, rowHeight, maxRows, autoSize, onDragStart, margin, containerPadding } =  this.props;
        const { items, openNew } = this.state;
        return (
                <React.Fragment>
                    <div className="pc-formgrid">
                        <GridLayout
                            style={styleGrid}
                            className={className}
                            width={this.props.width}
                            cols={cols}
                            rowHeight={rowHeight}
                            maxRows={maxRows}
                            margin={margin}
                            containerPadding={containerPadding || [0, 0]}
                            autoSize={autoSize}
                            onLayoutChange={this.onLayoutChange}
                            onDragStart={onDragStart}
                        >
                                {_.map(items, (el, index) => this.createElement(el, index, fields))}
                        </GridLayout>
                    </div>
                    {!hideAdd && (
                        <button type="button" className="pc-addrow" onClick={() => this.addCol()}>
                            <AddIcon sx={{ fontSize: 16 }} />
                            Добавить поле
                        </button>
                    )}
                    {openNew && (
                        <Modal
                            width={520}
                            title="Добавить поле в форму"
                            open={openNew}
                            handleSaveClick={this.onAddItem}
                            handleCloseClick={this.closeAddColl}
                            fields={<AddColFields items={items} fields={fields} />}
                            initial={addColInitial}
                            saveDisabled={(values) => !values || !values.field}
                        />
                    )}
                </React.Fragment>

        );
    }
}


const mapStateToProps = (state, props) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return { 
        formValues,
        isLoading: !!fetch.loading
    }
};

export default  compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false, // <------ preserve form data
        forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    }),
    withStyles(styles),
)(CardComponent);